export default {
  title: 'Terminal Management',

  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Terminal name, code',
    port: 'Port',
    portPlaceholder: 'Select port',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  actions: {
    addTerminal: 'Add Terminal',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    edit: 'Edit',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  table: {
    terminalName: 'Terminal Name (Chinese)',
    terminalNameEn: 'Terminal Name (English)',
    terminalCode: 'Terminal Code',
    terminalLink: 'Terminal Link',
    port: 'Port',
    operator: 'Operator',
    capacity: 'Capacity',
    status: 'Status',
    operation: 'Operation'
  },

  form: {
    addTitle: 'Add Terminal',
    editTitle: 'Edit Terminal',
    terminalName: 'Terminal Name',
    terminalCode: 'Terminal Code',
    port: 'Port',
    operator: 'Operator',
    capacity: 'Capacity',
    status: 'Status'
  },

  modal: {
    title: 'Select Terminal',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} terminals, total {total}'
  },

  confirm: {
    enableItem: 'Are you sure to enable this terminal?',
    disableItem: 'Are you sure to disable this terminal?'
  },

  messages: {
    selectToAdd: 'Please select terminals to add',
    selectToEnable: 'Please select terminals to enable',
    selectToDisable: 'Please select terminals to disable',
    loadError: 'Failed to load terminal data, please try again later',
    searchError: 'Failed to search terminals, please try again later',
    platformLoadError: 'Failed to load platform terminal data, please try again later',
    associateSuccess: 'Successfully associated {count} terminals',
    associateError: 'Failed to associate, please try again later',
    statusToggleSuccess: 'Terminal has been {status}',
    statusToggleError: 'Failed to toggle status, please try again later',
    batchEnableSuccess: 'Enabled {count} terminals',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchDisableSuccess: 'Disabled {count} terminals',
    batchDisableError: 'Failed to batch disable, please try again later'
  },

  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  },

  ports: {
    shanghai: 'Shanghai Port',
    shenzhen: 'Shenzhen Port',
    ningbo: 'Ningbo Port',
    qingdao: 'Qingdao Port',
    tianjin: 'Tianjin Port',
    guangzhou: 'Guangzhou Port',
    losangeles: 'Los Angeles Port',
    newyork: 'New York Port',
    rotterdam: 'Rotterdam Port',
    hamburg: 'Hamburg Port',
    singapore: 'Singapore Port',
    hongkong: 'Hong Kong Port'
  }
}